export default "__VITE_ASSET___lYG3hR2__"